import { KompisDefaultFields } from '@inter-ikea-kompis/services';
import { getProductService } from '../../services/ServiceHandler';
import { applicationSettings } from '../../settings/application';
import { setSprs } from '../sprs/sprsActions.ts';
import { setYmal } from '../ymal/ymalActions.ts';
import sprValid from '../../services/PacValidator';

export default function getCmsData() {
  return dispatch => {
    const app = applicationSettings.applicationName.toLowerCase();

    const cmsDataUrl = `/addon-app/${app}/content/latest/`;

    return fetch(cmsDataUrl, { credentials: 'same-origin', headers: { app } })
      .then(res => res.json())
      .then(data => {
        // YMAL
        const market = applicationSettings.country;

        const articleGroups = data.articleGroups;

        const setting =
          data.settings.find(setting => setting.id === market) ||
          data.settings.find(setting => setting.id === 'default');

        const articles = setting.ymals ? setting.ymals : [];

        dispatch(setYmal(articleGroups, articles));

        // SPRS
        const cmsSprs = data.sprs;
        const items = cmsSprs.map(spr => ({ type: 'SPR', id: spr.id }));

        const sprsPromise = getProductService()
          .getProducts(items, KompisDefaultFields)
          .then(dexfSprs => {
            const extendedSprs = cmsSprs.map(cmsSpr => {
              const matchingKompisSpr = dexfSprs.find(
                dexfSpr =>
                  dexfSpr.content?.ruItemNo === cmsSpr.id ||
                  dexfSpr.content?.itemNoGlobal === cmsSpr.id
              );
              return {
                ...cmsSpr,
                kompisSPR: matchingKompisSpr,
              };
            });
            const validSprs = extendedSprs.filter(
              spr => spr.kompisSPR?.valid && sprValid(spr)
            );
            if (validSprs.length) {
              dispatch(setSprs(validSprs));
            }
          });

        return Promise.resolve(sprsPromise);
      });
  };
}
